import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const SortBySelect = ({ sortOptions = null, sort = ["size", "desc"], onChange, label = "Sort By", ...props }) => {
  const handleChange = (e) => {
    const [field, direction] = e.target.value.split(":");
    onChange?.([field, direction]); // pass array back to parent
  };

  return (
    <FormControl fullWidth {...props}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={sort.join(":")}   // encode array as string
        onChange={handleChange}
        label={label}
      >
        {sortOptions.map((opt, idx) => (
          <MenuItem key={idx} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SortBySelect;